import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function CircleDoubleIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="12"
        viewBox="0 0 16 12"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.4979 11.8115C13.0387 10.3533 14 8.28892 14 6C14 3.71108 13.0387 1.64668 11.4979 0.188477C14.0868 0.853797 16 3.20347 16 6C16 8.79653 14.0868 11.1462 11.4979 11.8115Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10ZM6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
        />
      </svg>
    </Icon>
  );
}
